<template>
  <v-data-table
    :headers="headers"
    :items="lifeyrisgreidslur"
    :loading="loading"
    loading-text="Sæki gögn..."
    no-data-text="Engin gögn fundust"
    hide-default-footer
    :mobile-breakpoint="0"
    class="w-100"
    hover
  >
    <template #item.ar="{ item }">
      {{ item.ar }}
    </template>

    <template #item.greitt="{ item }">
      <div class="text-right">{{ currency(item.greitt) }}</div>
    </template>

    <template #item.greittAdrirSjodir="{ item }">
      <div class="text-right">{{ currency(item.greittAdrirSjodir) }}</div>
    </template>

    <template #item.stadgreidslaSkatta="{ item }">
      <div class="text-right">{{ currency(item.stadgreidslaSkatta) }}</div>
    </template>

    <template #item.utborgad="{ item }">
      <div class="text-right">{{ currency(item.utborgad) }}</div>
    </template>

    <template #item._actions="{ item }">
      <v-btn
        variant="text"
        icon="mdi-chevron-down"
        @click="$emit('open-year', item)"
        :aria-label="t('general_more')"
      />
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency'

const { t } = useI18n()
const { currency } = useCurrency()

defineProps<{
  lifeyrisgreidslur: any[]
  loading?: boolean
}>()

defineEmits<{
  (e: 'open-year', row: any): void
}>()

const headers = computed(() => [
  { title: t('lifeyrisTable_ar'), key: 'ar', align: 'start' as const, sortable: false },
  { title: t('lifeyrisTable_greitt'), key: 'greitt', align: 'end' as const, sortable: false },
  { title: t('lifeyrisTable_greittAdrirSjodir'), key: 'greittAdrirSjodir', align: 'end' as const, sortable: false },
  { title: t('lifeyrisTable_stadgreidslaSkatta'), key: 'stadgreidslaSkatta', align: 'end' as const, sortable: false },
  { title: t('lifeyrisTable_utborgad'), key: 'utborgad', align: 'end' as const, sortable: false },
  { title: t('general_more'), key: '_actions', align: 'end' as const, sortable: false },
])
</script>
